import { render, staticRenderFns } from "./意向转让.vue?vue&type=template&id=47d778e2&scoped=true"
import script from "./意向转让.vue?vue&type=script&lang=js"
export * from "./意向转让.vue?vue&type=script&lang=js"
import style0 from "./意向转让.vue?vue&type=style&index=0&id=47d778e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d778e2",
  null
  
)

export default component.exports